import objectFitImages from 'object-fit-images';
import 'babel-polyfill';
import './components';
import './views';


objectFitImages();



// WEBPACK FOOTER //
// ./src/my_artis/js/index.js